import { createSelector } from '@reduxjs/toolkit';
import { projectApi } from './project-api';

const selectProjectsResult = projectApi.endpoints.getProjects.select();

export const selectProjects = createSelector(
  [selectProjectsResult],
  (result) => result.data ?? [],
);
